import React from "react";
import { Container } from "react-bootstrap";
import "./styles.scss";
import img from "../../../assets/images/contact-image.png";
import { roofTypes } from "../../../util/constants";
import RoofType from "../RoofType";
import { Spring } from "react-spring/renderprops";

const SelectRoofType = ({ setStep, roofData, setRoofData }) => {
  return (
    <>
      <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {(props) => (
          <Container style={props} className="multi-form-step-section">
            <span>
              {" "}
              <div>
                <img
                  src={img}
                  className="toast-image mr-1"
                  alt="Helper Profile"
                />
              </div>
              <h5> What kind of roof would you like?</h5>
            </span>
            <div>
              <div className="roof-selection-section">
                {roofTypes.map((roofType, i) => (
                  <RoofType
                    key={i}
                    index={i}
                    setStep={setStep}
                    roofData={roofData}
                    setRoofData={setRoofData}
                    type={roofType.name}
                    image={roofType.image}
                  />
                ))}
              </div>
            </div>
          </Container>
        )}
      </Spring>
    </>
  );
};

export default SelectRoofType;
